<div class="warning-container">
    <div class="warning-header">
      <h2>{{ data.title || ('WARNING_DIALOG.DEFAULT_TITLE' | translate) }}</h2>
      <button class="close-button" (click)="onCancel()">
        <span class="close-icon">×</span>
      </button>
    </div>
<div class="warning-body">
      <div class="warning-content">
        <div class="warning-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <path fill="#FF9800" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
          </svg>
        </div>
        <div class="warning-message">
          <p class="main-message">{{data.message}}</p>
          <p class="sub-message">{{data.submessage}}</p>
        </div>
      </div>
    </div>
<div class="warning-footer">
      <button class="cancel-button" (click)="onCancel()">
        {{ ('WARNING_DIALOG.CANCEL' | translate) }}
      </button>
      <button class="confirm-button" (click)="onConfirm()">
        {{ ('WARNING_DIALOG.CONFIRM' | translate) }}
      </button>
    </div>
</div>